import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const PrivacyPage = () => (
  <Layout>
    <SEO title="Privacy Policy" />
    <div id="logo-container">
      <h1>Privacy Policy</h1>

      <p>Effective Date: 17 May 2025</p>

      <p>13one does not collect, store, or process any personal data or usage data of any kind. We do not sell, share, or transmit any user information to third parties because we do not collect any such information.</p>

      <p>However, please be aware that third-party services involved in the distribution or delivery of 13one — such as the Apple App Store, Google Play Store, or Cloudflare — may independently collect anonymous usage metrics or other data as part of their standard operations. 13one has no control over, and is not responsible for, the data collection practices of these third-party providers. We encourage users to review their respective privacy policies.</p>

      <p>If you have any questions about this privacy policy, you may contact us at <a href="mailto:stlyabsf@gmail.com">stlyabsf@gmail.com</a>.</p>
    </div>
  </Layout>
)

export default PrivacyPage
